module.exports = __webpack_public_path__ + "img/b400734.jpg";